<template>
  <div class="sqhd-wrapper" :style="{width:width*0.375+'px'}">
    <div class="sqhd-head" v-if="isShowDefaultTitle">社区活动</div>
    <div class="sqhd-item" :style="{padding:no125?'20px':'5px'}">
      <div class="item-top" :class="{'item_top_margin':!isShowDefaultTitle}">
        <img v-if="active.cover" :src="active.cover" class="top-pic box" :class="{'top-pic2':!isShowDefaultTitle}" :style="{height:imgHeight+'px'}">
        <div class="top-info box_f1">
          <div class="slh" >{{active.title}}</div>
          <div class="top-foot" v-if="active.sponsorName">
            <div class="iconfont icon-dangzhibugongzuo partyicon"></div>
            <div style="font-size:16px">{{active.sponsorName}}</div>
          </div>
        </div>
      </div>
      <x-scroll :contentArr="bmarr" :height="height*0.327" :lineNum="3" :width="width*0.1145" :time="3000" :chixuTime="3">
        <div class="item-down" slot="scroll" slot-scope="props" :style="{paddingTop:height*0.06+'px',width:width*0.1145+'px'}">
          <img :src="props.todo.headPicUrl" style="border-radius: 50%" :style="{height:height*0.23+'px',width:height*0.23+'px'}">
          <div class="baoming">
            <div style="padding-bottom: 5px">{{props.todo.userName}}</div>
            <div>{{props.todo.time}}</div>
          </div>
        </div>
      </x-scroll>
    </div>
  </div>
</template>

<script>
  import xScroll from '../../../components/xScroll'
  export default {
    components: {
      xScroll
    },
    props:{
      height:null,
      isShowDefaultTitle: {
        default: true,
        type: Boolean,
      },
      width:null,
      active:null,
      bmarr:null
    },
    computed:{
      imgHeight () {
        return this.height>300?this.height * 0.43:this.height * 0.38
      },
      no125 () {
        return this.height/0.302>750 || this.width > 1550?true:false
      },
    },
    data () {
      return {
        num:[1,2,3,4]
      }
    }
  }
</script>

<style scoped>
  .sqhd-wrapper{
    background: #fff;
    border:1px solid #fff;
    border-radius: 5px;
    padding-top: 20px;
    color:#444;
  }
  .sqhd-head{
    height: 20px;
    line-height: 20px;
    border-left: 3px solid #d22b2b;
    padding-left: 10px;
    font-size: 16px;
  }
  .sqhd-item{
    /*height:260px;*/
    width: 100%;
    /*padding: 20px;*/
    height:92%
  }
  .item-top{
    display: flex;
  }
  .item_top_margin{
    margin-bottom: 50px;
  }
  .partyicon{
    font-size: 16px;
    color: #ff5740;
    padding-right:5px
  }
  .top-info{
    font-size: 20px;
    position: relative;
    padding:5px 0;
    overflow: hidden;
  }
  .top-pic{
    /*height: 130px;*/
    /*width: 220px;*/
    width: 32.7%;
    margin-right: 15px
  }
  .top-pic2{
    height: 160px !important;
    width: 256px !important;
    margin-right: 15px
  }
  .top-foot{
    position: absolute;
    bottom:5px;
    left:0;
    display:flex
  }
  .item-down{
    /*width: 220px;*/
    display: flex;
  }
  .baoming{
    display: flex;
    padding-left:10px;
    flex-flow: column;
    justify-content:center;
    text-align: left;
    font-size:13px
  }
</style>
